'use client';

import { motion, useInView, useReducedMotion } from 'framer-motion';
import { useRef } from 'react';

import { springBounce, staggerContainer } from './animations';

const content = (
  <div className="flex flex-col items-center gap-20 text-center">
    <div className="flex flex-col items-center gap-8">
      <p className="font-400 text-Gray-white typo-body2">
        기부 할수록 혜택은 더 늘어나요
      </p>
      <h2 className="font-700 typo-h5">
        <span className="text-Gray-white">웰로가 MAX로 드려요~</span>
        <br />
        <span className="text-[#e4302c]">최대 135만원 상당 혜택</span>
      </h2>
    </div>
    <div className="flex size-48 items-center justify-center rounded-pill bg-[#e4302c]">
      <svg
        width="17"
        height="22"
        viewBox="0 0 17 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.76 13.85L9.08 21.75C9.01 21.83 8.91 21.89 8.81 21.93C8.71 21.98 8.61 22 8.5 22C8.39 22 8.29 21.98 8.18 21.93C8.08 21.89 7.99 21.83 7.92 21.75L0.24 13.85C-0.08 13.52 -0.08 12.99 0.24 12.66C0.56 12.33 1.08 12.33 1.4 12.66L7.68 19.11V0.85C7.68 0.38 8.05 0 8.5 0C8.95 0 9.32 0.38 9.32 0.85V19.11L15.6 12.66C15.92 12.33 16.44 12.33 16.76 12.66C17.08 12.99 17.08 13.52 16.76 13.85Z"
          fill="white"
        />
      </svg>
    </div>
  </div>
);

export const MaxBenefitSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-80px' });
  const shouldReduceMotion = useReducedMotion();

  if (shouldReduceMotion) {
    return (
      <section className="flex w-full flex-col items-center bg-Gray-black px-24 pb-40">
        {content}
      </section>
    );
  }

  return (
    <section className="flex w-full flex-col items-center bg-Gray-black px-24 pb-40">
      <motion.div
        ref={ref}
        variants={staggerContainer}
        initial="hidden"
        animate={isInView ? 'visible' : 'hidden'}
        className="flex w-full flex-col items-center"
      >
        <motion.div variants={springBounce}>{content}</motion.div>
      </motion.div>
    </section>
  );
};
